import React from "react";
import "leaflet/dist/leaflet.css";
import "./footer.css";
import Gallery from "./ImageGallery";

const Footer = React.forwardRef((props, ref) => {
  return (
    <footer className="footer" ref={ref} id={props.id}>
      <div className="footer-container">
        <div className="footer-contacts_map">
          <div className="footer-contacts">
            <h1 className="footer-contacts_title">Контакти</h1>
            <ul className="footer-contacts_container-list list">
              <li className="footer-contacts_list-item">
                <span className="footer-contacts_list-item_first">+38</span>
                <a
                  className="footer-contacts_list-link link"
                  href="tel:+3809968746956"
                >
                  (099) 687-46-56
                </a>
              </li>
              <li className="footer-contacts_list-item">
                <span className="footer-contacts_list-item_first">+38</span>
                <a
                  className="footer-contacts_list-link link"
                  href="tel:+380985598685"
                >
                  (098) 559-86-85
                </a>
              </li>
              <li className="footer-contacts_list-item">
                <span className="footer-contacts_list-item_first">+38</span>
                <a
                  className="footer-contacts_list-link link"
                  href="tel:+380994367500"
                >
                  (099) 436-75-00
                </a>
              </li>
            </ul>
            <ul className="social_network-list list">
              <li className="social_network-item">
                <a href="https://www.instagram.com/garant_krovlia?igsh=MTRza253ZnpvY3UwZg%3D%3D&utm_source=qr">
                  <svg viewBox="0 0 32 32" className="social_network_svg">
                    <use href="./img/sprite.svg#insta"></use>
                  </svg>
                </a>
              </li>
              <li className="social_network-item">
                <a href="https://t.me/jkrovlia">
                  <svg viewBox="0 0 32 32" className="social_network_svg">
                    <use href="./img/sprite.svg#telega"></use>
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div className="gallery_container">
            <h1 className="gallery_container-title">Наші роботи</h1>
            <Gallery />
          </div>
        </div>
      </div>
      <div className="footer_bot">
        <div className="footer_bot-info">
          Компанія KrovliaExpert Всі права захищені. © 2021.
        </div>
      </div>
    </footer>
  );
});

export default Footer;
